import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../../config/images/gambar';
import CollapseMenu from '../../../../config/atoms/CollapseMenu';
import MenuDetail from '../MenuDetail';
import { Link } from 'react-router-dom';
import { Capitalize, DateIndo } from '../../../../utils/helpers';
import tableAddOns from '../../../../config/atoms/TableAddOns';
import swal from 'sweetalert';
import { dataKRS, dataKHS } from '../../../../dummy-data/krs-khs';
import { dataMahasiswa } from '../../../../dummy-data/mahasiswa';


var nowDate = new Date();
var tanggal = DateIndo(nowDate);

class Krs extends Component {
    state = {
        ttd: "",
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: ''
        },
        OptSemester: [],
        listPengajuan: {
            data: [],
            sks_semesterini: 0,
            sks_semuasemester: 0,
            sksteori_semesterini: 0,
            skspraktek_semesterini: 0,
            sksteori_semuasemester: 0,
            skspraktek_semuasemester: 0
        },
        isLoading: false,
        selectedSemester: '-',

        // params
        idVal: '',
        nimVal: ''
    }

    getAllData = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);
        const krsData = dataKRS.filter(k => k.nim === nim);

        // Get unique semesters from KRS and KHS data
        const khsData = dataKHS.filter(k => k.nim === nim);
        const semestersFromKHS = [...new Set(khsData.map(k => k.semester_ke))];
        const semestersFromKRS = [...new Set(krsData.map(k => k.semester_ke))];
        const allSemesters = [...new Set([...semestersFromKHS, ...semestersFromKRS])].sort((a, b) => a - b);

        this.setState({
            user: {
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                kdjur: 'TI',
                kurikulum: '2020',
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                nim: nim,
                semester: allSemesters.length > 0 ? Math.max(...allSemesters) : 7,
                smtta: 'Ganjil',
                ta: '2024/2025'
            },
            OptSemester: allSemesters.map(s => ({ semester: s }))
        });
    }

    getHistoryPengajuan = (e) => {
        this.setState({ isLoading: true });

        const nim = this.state.nimVal;
        const semesterKe = parseInt(e.target.value);

        // Filter KRS data by semester
        const krsFiltered = dataKRS.filter(k => k.nim === nim && k.semester_ke === semesterKe);

        // Map to expected format
        const mappedData = krsFiltered.map(k => ({
            idkrs: k.krs_id,
            kodemk: k.kode_mk,
            namamk: k.nama_mk,
            kodekelas: k.kelas,
            statuskrs: k.status,
            statusmagang: false,
            sksteori: k.sks,
            skspraktek: 0,
            bu: 'B'
        }));

        const totalSKS = mappedData.reduce((sum, m) => sum + m.sksteori + m.skspraktek, 0);

        setTimeout(() => {
            this.setState({
                listPengajuan: {
                    data: mappedData,
                    sks_semesterini: totalSKS,
                    sks_semuasemester: totalSKS * semesterKe,
                    sksteori_semesterini: mappedData.reduce((sum, m) => sum + m.sksteori, 0),
                    skspraktek_semesterini: 0,
                    sksteori_semuasemester: totalSKS * semesterKe,
                    skspraktek_semuasemester: 0
                },
                selectedSemester: e.target.value,
                isLoading: false
            });
        }, 300);
    }

    // handler untuk checkbox magang
    handleMagangChange = (idkrs, checked) => {
        swal({
            icon: "success",
            title: "Demo Mode",
            text: "Status magang berhasil diupdate (simulasi)",
            buttons: false,
            timer: 1500,
        });
    };


    // handle to print 
    print = () => {
        const doc = new jsPDF();

        var imageAsia = Image.data

        doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19)

        var width = doc.internal.pageSize.getWidth()
        doc.setFont("Times-bold", "bold")
        doc.setFontSize(11.5);
        doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);
        let prodi = this.state.user.jurusan;
        let fakultas;
        if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
            fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN"
        } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
            fakultas = "FAKULTAS EKONOMI DAN BISNIS"
        }
        doc.text(fakultas, width / 2, 36.5, { align: 'center' });

        doc.setFont("Times-Roman", "normal");
        doc.setFontSize(11.5);
        doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 41.5, { align: 'center' });

        doc.setLineWidth(0.1)
        doc.line(10, 47, 200, 47)

        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);

        doc.text("KARTU RENCANA STUDI", width / 2, 56, { align: 'center' });

        doc.autoTable({
            html: '#headerTabel',
            startY: doc.lastAutoTable + 63,
            theme: 'plain',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '10.5',
                cellPadding: 0.5
            },
            margin: { left: 10, right: 10 }
        });

        doc.autoTable({
            html: '#tabelKRS',
            theme: 'grid',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                valign: 'middle',
            },
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 'black',
                valign: 'middle',
                halign: 'center',
                lineWidth: 0.1
            },
            columnStyles: {
                0: { cellWidth: 10, halign: 'center' },
                1: { cellWidth: 30, halign: 'center' },
                2: { cellWidth: 50, halign: 'center' },
                3: { cellWidth: 25, halign: 'center' },
                4: { cellWidth: 25, halign: 'center' },
                5: { cellWidth: 25, halign: 'center' },
                6: { cellWidth: 25, halign: 'center' }

            },
            margin: { top: 10, left: 10, right: 10, bottom: 10 },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 2) {
                    data.cell.styles.fontStyle = 'bold'
                }
                if (data.row.index === rows.length - 1) {
                    data.cell.styles.fontStyle = 'bold'
                }
            }
        });

        doc.autoTable({
            html: '#ttd',
            theme: 'plain',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '10.5',
                cellPadding: 0.1,
                halign: 'center',
            },
            margin: { top: 20, left: 110, bottom: 20 },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 2) {
                    data.cell.styles.cellPadding = -4
                }
                if (data.row.index === rows.length - 1) {
                    data.cell.styles.cellPadding = 1
                }
                if (data.row.index === rows.length - 9) {
                    data.cell.styles.cellPadding = 1
                }
            }
        });

        window.open(doc.output('bloburl'), '_blank')
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData();
        })
    }

    componentDidMount = () => {
        document.getElementById("krsMenu").classList.add("active");
        CollapseMenu();
        this.setParams()
    };

    render() {
        // underline for report 
        var i2;
        let output2 = "";
        for (i2 = 1; i2 < this.state.ttd.length; i2++) {
            output2 += "_";
        }
        // end underline for report 

        const { OptSemester, isLoading, selectedSemester } = this.state
        const { angkatan, jurusan, nama, nim, semester, ta } = this.state.user
        const { data, sks_semesterini, sks_semuasemester, sksteori_semesterini, skspraktek_semesterini, skspraktek_semuasemester, sksteori_semuasemester } = this.state.listPengajuan

        const statusTheme = (val) => {
            if (val === 'Disetujui') return 'success'
            else if (val === 'Ditolak') return 'danger'
            else if (val === 'Aktif') return 'info'
            else if (val === 'Konversi') return 'warning'
            else return 'primary'
        }

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Detail KRS
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>
                    <div className="col-xl-9" id="kontenKiri">
                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                    Kartu Rencana Studi
                                </p>
                                <div className="table-responsive pl-2 pr-2">
                                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <td>NIM</td>
                                                <td> : </td>
                                                <td>{nim}</td>

                                                <td>Angkatan</td>
                                                <td> : </td>
                                                <td>{angkatan}</td>
                                            </tr>
                                            <tr>
                                                <td>Nama</td>
                                                <td> : </td>
                                                <td>{nama}</td>

                                                <td>Semester</td>
                                                <td> : </td>
                                                <td>
                                                    <select onChange={this.getHistoryPengajuan} className="form-control custom-width" id="selectSemester" disabled={this.state.isLoading}>
                                                        <option value="" hidden>- pilih semester -</option>
                                                        {
                                                            OptSemester.map((v, index) => {
                                                                return (
                                                                    <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <br />
                                <Link
                                    to={{

                                        pathname: "/data-mahasiswa/pengajuanKrs/" + this.state.idVal,

                                        state: this.state.user
                                    }}
                                    className="btn btn-add" style={{ marginBottom: '25px' }} >
                                    <i className="ti-marker-alt"></i>&nbsp;&nbsp;Pengajuan KRS
                                </Link>
                                <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                    Kartu rencana studi mahasiswa :
                                </p>
                                <div className="table-responsive">
                                    <table width="100%" align="center" className="display expandable-table table-bordered table-radius"
                                    >
                                        <thead>
                                            <tr align="center">
                                                <th>
                                                   
                                                </th>
                                                <th>No</th>
                                                <th>Kode Mata Kuliah</th>
                                                <th>Nama Mata Kuliah</th>
                                                <th>Kode Kelas</th>
                                                <th>Status</th>
                                                <th>Status Magang</th>
                                                <th>SKS Teori</th>
                                                <th>SKS Praktek</th>
                                                <th>B/U</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                !isLoading ?
                                                    data.length !== 0 ?
                                                        data.map((v, index) => {
                                                            return (
                                                                <tr height={10} key={index}>
                                                                    <td align="center">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={v.statusmagang}
                                                                            onChange={(e) => this.handleMagangChange(v.idkrs, e.target.checked)}
                                                                        />
                                                                    </td>
                                                                    <td align="center">{index + 1}</td>
                                                                    <td align="center">
                                                                        <button type="button"
                                                                            title="detail nilai mk"
                                                                            className="btn btn-primary btn-sm btn-nilai"
                                                                            data-toggle="modal" data-target="#nilai">
                                                                            {v.kodemk}
                                                                        </button>
                                                                    </td>
                                                                    <td>{v.namamk}</td>
                                                                    <td>{v.kodekelas}</td>
                                                                    <td align="center">
                                                                        <span className={`badge badge-${statusTheme(v.statuskrs)}`} style={{ fontSize: '14px' }}>
                                                                            {v.statuskrs}
                                                                        </span>
                                                                    </td>
                                                                    <td align="center">
                                                                        <span className={`badge badge-${v.statusmagang ? 'success' : 'danger'}`} style={{ fontSize: '14px' }}>
                                                                            {v.statusmagang ? 'Ya' : 'Tidak'}
                                                                        </span>
                                                                    </td>
                                                                    <td align="center">{v.sksteori}</td>
                                                                    <td align="center">{v.skspraktek}</td>
                                                                    <td align="center">{v.bu}</td>
                                                                </tr>
                                                            )
                                                        })
                                                        : <> {tableAddOns('null')} </>
                                                    : <> {tableAddOns('loading')} </>
                                            }
                                        </tbody>

                                        <tfoot>
                                            <tr className="customPadding customTable">
                                                <td colSpan={7}>Total SKS Semester Ini</td>
                                                <td align="center">{sksteori_semesterini}</td>
                                                <td align="center">{skspraktek_semesterini}</td>
                                                <td align="center">{sks_semesterini}</td>
                                            </tr>
                                            <tr className="customPadding customTable">
                                                <td colSpan={7}>Total SKS yang sudah diambil s.d. semester {semester}</td>
                                                <td align="center">{sksteori_semuasemester}</td>
                                                <td align="center">{skspraktek_semuasemester}</td>
                                                <td align="center">{sks_semuasemester}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <br />
                                <button className="btn btn-success" type="button" style={{ float: 'right' }}
                                    onClick={this.print}
                                >
                                    <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak KRS .PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* print area  */}
                <div style={{ display: 'none' }}>
                    <div>
                        <table id="headerTabel">
                            <thead></thead>
                            <tbody className='times'>
                                <tr>
                                    <td>Nama</td>
                                    <td> : </td>
                                    <td>{Capitalize(nama)}</td>

                                    <td>Tahun Angkatan</td>
                                    <td> : </td>
                                    <td>{angkatan}</td>
                                </tr>
                                <tr>
                                    <td>NIM</td>
                                    <td> : </td>
                                    <td>{nim}</td>

                                    <td>Tahun Akademik</td>
                                    <td> : </td>
                                    <td>{ta}</td>
                                </tr>
                                <tr>
                                    <td>Program Studi</td>
                                    <td> : </td>
                                    <td>{jurusan}</td>

                                    <td>Semester</td>
                                    <td> : </td>
                                    <td>{selectedSemester}</td>
                                </tr>
                                <tr>
                                    <td>Konsentrasi</td>
                                    <td> : </td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="tabelKRS">
                            <thead>
                                <tr align="center">
                                    <th>No</th>
                                    <th>Kode Mata Kuliah</th>
                                    <th>Nama Mata Kuliah</th>
                                    <th>Kode Kelas</th>
                                    <th>SKS Teori</th>
                                    <th>SKS Praktek</th>
                                    <th>B/U</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.length !== 0 ?
                                        data.map((v, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td align="center">{index + 1}</td>
                                                    <td align="center">{v.kodemk}</td>
                                                    <td>{v.namamk}</td>
                                                    <td>{v.kodekelas}</td>
                                                    <td align="center">{v.sksteori}</td>
                                                    <td align="center">{v.skspraktek}</td>
                                                    <td align="center">{v.bu}</td>
                                                </tr>
                                            )
                                        })
                                        : <> {tableAddOns('null')} </>
                                }
                                <tr>
                                    <td colSpan={4}>Total SKS Semester Ini</td>
                                    <td>{sksteori_semesterini}</td>
                                    <td>{skspraktek_semesterini}</td>
                                    <td>{sks_semesterini}</td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>Total SKS yang sudah diambil s.d. semester {semester}</td>
                                    <td>{sksteori_semuasemester}</td>
                                    <td>{skspraktek_semuasemester}</td>
                                    <td>{sks_semuasemester}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="ttd">
                            <tbody>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>Malang, {tanggal}</td>
                                </tr>
                                <tr>
                                    <td>Dosen Wali,</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        {this.state.ttd}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {output2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>NIDN.{this.state.nidn}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* end of print area  */}
            </Fragment>
        );
    }
}

export default Krs;